(() => {
  const hydrateFilm = (video) => {
    if (!video || video.dataset.dlHydrated === 'true') return;
    const source = video.querySelector('source[data-src]');
    if (video.dataset.poster) video.poster = video.dataset.poster;
    if (source?.dataset.src) source.src = source.dataset.src;
    video.dataset.dlHydrated = 'true';
    video.load?.();
  };

  const setupFilm = (root) => {
    const video = root.querySelector('.dl-home-film video');
    if (!video) return;
    const load = () => hydrateFilm(video);
    video.addEventListener('focus', load, { once: true });
    video.addEventListener('pointerenter', load, { once: true });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        load();
      }, { rootMargin: '180px 0px' });
      observer.observe(video);
    }
  };

  const setupDesktopMedia = () => {
    const video = document.querySelector('[data-dl-desktop-video]');
    if (!video || !('matchMedia' in window)) return;
    const desktop = window.matchMedia('(min-width: 750px)');
    const loadForDesktop = () => { if (desktop.matches) hydrateFilm(video); };
    loadForDesktop();
    desktop.addEventListener?.('change', loadForDesktop, { once: true });
  };

  const setupDiscovery = (root) => {
    const cards = [...root.querySelectorAll('[data-dl-product-card]')];
    const groups = [...root.querySelectorAll('[data-dl-product-group]')];
    const buttons = [...root.querySelectorAll('[data-dl-filter]')];
    const search = root.querySelector('[data-dl-search] input[type="search"]');
    const results = root.querySelector('[data-dl-results]');
    if (!cards.length) return;
    let category = 'all';

    const apply = () => {
      const query = search?.value.trim().toLocaleLowerCase() ?? '';
      let shown = 0;
      cards.forEach((card) => {
        const categoryMatch = category === 'all' || card.dataset.dlCategory === category;
        const queryMatch = !query || (card.dataset.dlTitle ?? '').includes(query);
        card.hidden = !(categoryMatch && queryMatch);
        if (!card.hidden) shown += 1;
      });
      groups.forEach((group) => { group.hidden = !group.querySelector('[data-dl-product-card]:not([hidden])'); });
      if (results) results.textContent = shown ? `Showing ${shown} selected ${shown === 1 ? 'piece' : 'pieces'}.` : 'No selected pieces match. Search the complete catalog or clear the filters.';
    };

    buttons.forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.dlFilter ?? 'all';
      buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      apply();
    }));
    search?.addEventListener('input', apply);
  };

  const init = () => document.querySelectorAll('[data-dl-mobile-home]').forEach((root) => {
    if (root.dataset.dlReady === 'true') return;
    root.dataset.dlReady = 'true';
    setupDiscovery(root);
    setupFilm(root);
  });

  init();
  setupDesktopMedia();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
})();
